<script>
import resources from './resources'

export default {
  name: 'patient-notificacoes',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Notificações", icon="")
    .col-xs-12.content
      .container-fluid.zero-margin
        .row(v-if="loading")
          spinner(:show="true")
        .row.m-t-20(v-if="!loading")
            #notifications.col-xs-12.white-bg
                .row
                    .col-xs-12
                        .row
                         .col-xs-12(style='border-bottom:1px solid #e5e7e7;')
                            button.btn.find.desktop-right
                             span.icon 
                             | Histórico de Notificações
                    .col-sm-10
                        h4 Notificações
                        .item
                            span.icon.alert 
                            |Cadastre um Endereço de Correspondência
                            br
                            small 2 dias atrás
                        .item
                            span.icon.alert 
                            |  Valide seu Número  de Celular
                            br
                            small 1 mês atrás

                        .divider
                        h4 Próximos Eventos Agendados
                        .item
                            span.icon.agenda 
                            | 08:00 - 25/03 - Maria da Silva (Agendado)
                            br
                            small
                            | Dr. Igor Popadiuk (Clínica Médica)
                            br
                            |Rua Buenos Aires, 441 - Batel - Curitiba - PR
                            br
                            br
                        .item
                            span.icon.agenda 
                            | 14:20 - 2531/03 - Lucas Pereira da Silva (Transferido)
                            br
                            small
                            | Dra. Célia Mendes (Dermatologista)
                            br
                            |Praça Rui Barbosa, 441 - Centro - Curitiba - PR
                            br
                            br

</template>
<style scoped>
.m-t-20 {
    margin-top: 30px;
}
#notifications .item {
    color: #5b647a;
    font-size: 1.1em;
    margin-left: 28px;
    cursor: default;
    line-height: 150%;
}
#notifications .icon.alert {
color: #FFcd00 !important;
-webkit-box-shadow: none;
box-shadow: none;
padding: 0 !important;
}
#notifications .item .icon {
    margin-left: -28px;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/notifications/index/notifications.vue